import { AceProjektAceProjektEnumsAceProjektStatuscode } from './../../../../../api/models/ace/xFound/Portal/Core/Entities/ace-projekt-ace-projekt-enums-ace-projekt-statuscode';
import { AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode } from './../../../../../api/models/ace/xFound/Portal/Core/Entities/ace-ausschreibung-ace-ausschreibung-enums-ace-ausschreibung-statuscode';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { GlobalEnumsAcePortalstatus } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-portalstatus';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { StateService } from '@/core/services/state.service';
import { DocumentService, AnfrageService } from '@/api/service-index';
import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { FormularService } from '@/core/services/formular.service';
import { PortalContextService } from '@/core/services/portal-context.service';
import { GlobalEnumsAceXfoundportalobjekt } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-xfoundportalobjekt";
import { I18nService } from '@/core/services/i18nService';
import { RevokeReasonAnfrageDialogComponent, RevokeReasonAnfrageDialogResult } from '../../dialogs/revoke-reason-anfrage-dialog/revoke-reason-anfrage-dialog.component';
import { ConfirmationDialogResult, ConfirmationDialogComponent, ConfirmationDialogAction } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { AnfrageListFactory } from '@/core/factories/anfrage-list.factory';
import { AnfrageContract } from '@/core/models/abstractions/anfrage.contract';
import { AnfrageLiveSharingService } from '@/core/services/anfrage-live-sharing.service';
import { ChatDialogComponent } from '../../dialogs/chat-dialog/chat-dialog.component';
import { DocumentSelectionDialogComponent, UnterlagenDialogResult } from '@/core/components/document/document-selection-dialog/document-selection-dialog.component';
import { DocumentService as ClientDocumentService } from '@/core/services/document.service';
import { AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode, GlobalEnumsAceJaNein, GlobalEnumsAceMittelabruf, GlobalEnumsAceTypphase, GlobalEnumsAceTypprojektbericht, LocalizedTextDisplayModel, RevokeDisplayModel } from '@/api/model-index';
import { Constants } from '@/constants';
import { GlobalEnumsAceAnzeigestatusportal } from '@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-anzeigestatusportal';
import * as moment from 'moment';

@Component({
  selector: 'anfrage-card',
  templateUrl: './anfrage-card.component.html',
  styleUrls: ['./anfrage-card.component.scss']
})
export class AnfrageCardComponent implements OnInit {

  /**
   * Dialogs
   */
  protected deleteAnfrageDialog: DialogRef;
  protected revokeAnfrageDialog: DialogRef;
  protected revokeReasonAnfrageDialog: DialogRef;

  /**
   * Anfrage Instance
   */
  protected instance: AnfrageContract | null;

  /**
   * Anfrage
   */
  public anfrage: AnfrageListDisplayModel;

  /**
   * Portalkonfiguration
   */
  public portalkonfiguration: PortalkonfigurationDisplayModel;

  /**
   * Set Anfrage
   */
  @Input('anfrage')
  public set setAnfrage(value: AnfrageListDisplayModel) {
    this.anfrage = value;
  };

  @Output('anfrageDelete') anfrageDeleteEventEmitter: EventEmitter<AnfrageListDisplayModel> = new EventEmitter<AnfrageListDisplayModel>();

  constructor(
    protected formularService: FormularService,
    protected anfrageService: AnfrageService,
    protected documentService: DocumentService,
    protected clientDocumentService: ClientDocumentService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected dialogService: DialogService,
    protected ngxSpinnerService: NgxSpinnerService,
    protected loadingAnimationService: LoadingAnimationService,
    protected stateService: StateService,
    protected portalContextService: PortalContextService,
    protected languageService: I18nService,
    protected anfrageListFactory: AnfrageListFactory,
    protected anfrageLiveSharingService: AnfrageLiveSharingService) {
      //
    }

  ngOnInit(): void {
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;

    this.instance = this.anfrageListFactory.create(this.anfrage);
  }

  /**
   * Get the title.
   * 
   * @returns string
   */
  public get title(): string {
    return this.anfrage.nummer + " - " + (this.anfrage.name ?? this.languageService.instant('newAnfrageTitle'));
  }

  /**
   * Get the ausschreibung.
   * 
   * @returns string
   */
  public get ausschreibung(): string {
    return this.anfrage.ausschreibungName ?? this.languageService.instant('undefinedText');
  }

  /**
   * Get the bereich.
   * 
   * @returns string
   */
  public get bereich(): string {
    return this.anfrage.foerderprogrammName ?? this.languageService.instant('undefinedText');
  }

  /**
   * Get the phase description.
   * 
   * @returns string
   */
  public get phaseDescription(): string {
    if (! this.anfrage.phase || ! this.anfrage.phase.name)
      return this.languageService.instant('undefinedText');

    let title: LocalizedTextDisplayModel | undefined = this.languageService.getCurrentLocalizedTextDisplayModel(this.anfrage.phase.name);
      return title?.text ?? "";
  }

  /**
   * Is Anfrage in Editable State
   * 
   * @returns boolean
   */
  public get isEditable(): boolean {
    if (this.isBerichtVisible) return false;
    
    if (this.anfrage.ausschreibungsStatus == AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.InDurchfuhrung
      && this.anfrage.portalStatus != GlobalEnumsAcePortalstatus.Ausschreibungabgelaufen
      && this.instance?.isInProgress
      && this.instance?.isDraft)
      return true;

    if (this.instance?.isInProgress && ! this.instance?.isDraft
    && (this.anfrage.freigegebenbis == null
      || (moment(Date.now()).isSameOrBefore(moment(this.anfrage.freigegebenbis), "day")))
    && (this.anfrage.freigegebenZurUeberarbeitung == null
      || (moment(Date.now()).isSameOrAfter(moment(this.anfrage.freigegebenZurUeberarbeitung), "day"))))
      return true;

    return false;
  }

  /**
   * Is Anfrage in Mittelabruf State
   */
  public get isMittelabrufVisible(): boolean {
    if (this.portalkonfiguration.artDesMittelabrufs != GlobalEnumsAceMittelabruf.Keiner) {
      if (
        (this.isInDurchfuehrung || this.isInAbschluss) && !this.isRevoked && !this.isRejected
         && this.anfrage.mittelabrufSperren != GlobalEnumsAceJaNein.Ja) {
        return true;
      }
    }
    
    return false;
  }

  public get isInDurchfuehrung(): boolean {
    return this.anfrage?.objektTyp == GlobalEnumsAceXfoundportalobjekt.Projekt && this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.Durchfuhrung;
  }

  public get isInAbschluss(): boolean {
    return this.anfrage?.objektTyp == GlobalEnumsAceXfoundportalobjekt.Projekt && this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.Abschluss;
  }

  /**
   * Is Anfrage not in Mittelabruf State
   */
  public get isNotMittelabruf(): boolean {
    if (! this.instance?.isInProgress && this.anfrage.status != <number>AceProjektAceProjektEnumsAceProjektStatuscode.Abschluss)
      return false;

    return true;
  }

  /**
   * is Anfrage Rejected
   */
  public get isRejected():boolean{
    return (this.anfrage.objektTyp == GlobalEnumsAceXfoundportalobjekt.Projekt && this.anfrage.status == AceProjektAceProjektEnumsAceProjektStatuscode.Abgelehnt ) ||
     (this.anfrage.objektTyp == GlobalEnumsAceXfoundportalobjekt.Projektidee && this.anfrage.status == AceProjektideeAceProjektideeEnumsAceProjektideeStatuscode.Abgelehnt) ;
  }

  /**
   * Is Anfrage in Closed State
   */
  public get isClosed(): boolean {
    return !this.isRevoked
      && !this.isExpired
      && !this.isSent
      && !this.isEditable
      && !this.isMittelabrufVisible
      && !this.isBerichtVisible
      && !this.isRejected;
  }

  /**
   * Is Anfrage in Expired State
   */
  public get isExpired(): boolean {
    if (this.isDraft && ! this.instance?.isInProgress)
      return true;

    if (this.isDraft && this.instance?.isInProgress && this.anfrage.ausschreibungsStatus != AceAusschreibungAceAusschreibungEnumsAceAusschreibungStatuscode.InDurchfuhrung)
      return true;

    return false;
  }

  /**
   * Determine if anfrage is in sent state.
   * 
   * Anfrage is in sent state if:
   * - Anfrage is not in draft state
   * - Anfrage is not in revoked state
   * - Anfrage is in portal status closed
   * 
   * @returns boolean
   */
  public get isSent(): boolean {
    if (! this.isDraft && ! this.isRevoked && this.isPortalStatusClosed && ! this.isRejected)
      return true;

    return false;
  }

  /**
   * Determine if anfrage is in portal status closed.
   * 
   * @returns boolean
   */
  public get isPortalStatusClosed(): boolean
  {
    return this.anfrage.portalStatus == GlobalEnumsAcePortalstatus.geschlossen;
  }
  
  /**
   * Is Anfrage in Revoked State
   */
  public get isRevoked(): boolean
  {
    return this.instance?.markedAsRevoked ?? false;
  }

  /**
   * Determine if anfrage is in draft state.
   * 
   * @returns boolean
   */
  public get isDraft(): boolean {
    return this.instance?.isDraft ?? false;
  }

  // public get isAntragsdatenblattAvailable() : boolean
  /**
   * Is any Antragsdatenblatt available
   * 
   * Show Antragsdatenblatt Button if:
   * - Anfrage has Antragsdatenblatt
   */
  public get isAntragsdatenblattAvailable() : boolean
  {
    return this.anfrage.hasAntragsdatenblatt == true;
  }

  /**
   * Anfrage is Revokeable if:
   * - Anfrage is not in Editable State
   * - Anfrage is in Erfasst, InPrufung or Befurwortet State
   * - Anfrage is in Erfasst, InPrufung or Entscheidung State
   */
  public get isRevokable(): boolean {
    if (this.portalkonfiguration.zurueckziehenDeaktivieren === true)
      return false;

    if (! this.instance?.isRevokable || this.isEditable || this.isRevoked)
      return false;

    if (! this.instance?.isDraft && ! this.instance?.isInProgress)
      return true;

    return false;
  }

  public get isBerichtVisible(): boolean {
    return this.isBerichtPhase && this.anfrage.berichtVorhanden == true;
  }

  public get isBerichtPhase(): boolean {
    return this.anfrage.objektTyp == GlobalEnumsAceXfoundportalobjekt.Projekt && (this.anfrage.phase?.typ == GlobalEnumsAceTypphase.Bericht || this.anfrage.phase?.typ == GlobalEnumsAceTypphase.Abschluss);
  }

  public get isViewVisible(): boolean {
    return (this.isSent || this.isExpired || this.isClosed || this.isRevoked || this.isRejected) && !this.isBerichtPhase;
  }

  public get isMessageVisible(): boolean {
    return this.portalkonfiguration.nachrichtenInSidebarAnzeigen ?? false;
  }

  public get freigabeAktiviert(): boolean {
    return this.portalkonfiguration.freigabeDeaktivieren != GlobalEnumsAceJaNein.Ja;
  }

  public get getEnqCardText(): string {
    let dataset = GlobalEnumsAceAnzeigestatusportal.getAsDataset();
    var text = ""
    
    if(this.isExpired){
      text = dataset.find((value) => value.Value == GlobalEnumsAceAnzeigestatusportal.Abgelaufen)?.Name?? "";
    }
    else{
      text = dataset.find((value) => value.Value == this.anfrage.anzeigestatus)?.Name?? "";
    }
    if(text !="")
      return this.languageService.instant("Enum.GlobalEnumsAceAnzeigestatusportal." + text);
    return "";
  }

  get IsAnyBerichtInBearbeitung(): boolean{
    return (this.isBerichtVisible == true && this.anfrage.berichtInBearbeitung == true);
  }
  
  public onEditClick() {
    this.openApplication();
  }

  public onViewClick() {
    this.openApplication();
  }

  public onTitleClick() {
    if (this.isBerichtVisible)
      this.onBerichtClick();
    else if(this.isEditable || this.isViewVisible)
      this.openApplication();
  }

  public onMittelAbrufenClick() {
    if (! this.portalkonfiguration.artDesMittelabrufs) {
      return;
    }

    switch (this.portalkonfiguration.artDesMittelabrufs) {
      case GlobalEnumsAceMittelabruf.Zahlung:
        return this.router.navigate(['../', 'funds', this.anfrage.objektTyp, this.anfrage.id, 'payment'], { relativeTo: this.route });
      case GlobalEnumsAceMittelabruf.Forderbetrag:
        return this.router.navigate(['../', 'funds', this.anfrage.objektTyp, this.anfrage.id, 'funding-amount'], { relativeTo: this.route });
    }
    return;
  }

  public onAntragsdatenblattClick() {
    let subscription = this.anfrageService.apiAnfrageAnfrageIdAntragsdatenblaetterGet({
      'x-anfragescope': this.anfrage.objektTyp,
      anfrageId: this.anfrage.id,
      loadContent: false
    }).subscribe(response => {
      this.unterlagenDialog = this.dialogService.open({
        content: DocumentSelectionDialogComponent,
        maxWidth: Constants.DIALOG.MAX_WIDTH,
        maxHeight: Constants.DIALOG.MAX_HEIGHT,
        width: Constants.DIALOG.WIDTH,
        title: this.languageService.instant("anfrage.antragsdatenblaetter.dialog-title")
      });

      let dialogComponent: DocumentSelectionDialogComponent = this.unterlagenDialog.content.instance;
      dialogComponent.documents = response;

      this.unterlagenDialog.result.subscribe(result => {
        this.onUnterlagenDialogClose(<UnterlagenDialogResult>result);
      });
    })

    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  protected onUnterlagenDialogClose(result: UnterlagenDialogResult) {
    if (!result.documentsToDownload || result.documentsToDownload.length < 1)
      return;

    let documentIds: string[] = result.documentsToDownload.map(document => document.documentId + "");

    let subscription = this.anfrageService.apiAnfrageAnfrageIdAntragsdatenblaetterGet({
      'x-anfragescope': this.anfrage.objektTyp,
      anfrageId: this.anfrage.id,
      loadContent: true
    }).subscribe(response => {
        response.forEach(file => this.clientDocumentService.download(file));
    })
    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  public onDeleteClick() {
    this.deleteAnfrageDialog = this.dialogService.open({
      content: ConfirmationDialogComponent,
      maxWidth: Constants.DIALOG.MAX_WIDTH,
      maxHeight: Constants.DIALOG.MAX_HEIGHT,
      width: Constants.DIALOG.WIDTH,
      title: this.languageService.instant("deleteprojectdialogue.title")
    });

    let dialogComponent: ConfirmationDialogComponent = this.deleteAnfrageDialog.content.instance;

    dialogComponent.content = "deleteenquiry.infoText";
    dialogComponent.confirm = "deleteenquiry.delete";

    this.deleteAnfrageDialog.result.subscribe(result => this.onDeleteProjektDialogClose(<ConfirmationDialogResult>result));
  }

  protected unterlagenDialog: DialogRef;

  public onBerichtClick() {
    let subscription = this.anfrageService.apiAnfrageAnfrageIdBerichtGet({ 'x-anfragescope': this.anfrage.objektTyp, anfrageId: this.anfrage.id }).subscribe(response => {
      if (this.anfrage.phase && this.anfrage.phase.abschnitte && response.projektberichte && response.projektberichte.length > 0) {
        let link: string[];
        
        if (response.projektberichte[0].typ == GlobalEnumsAceTypprojektbericht.Zwischenbericht && this.anfrage.phase.typ == GlobalEnumsAceTypphase.Abschluss && response.abschnitteZwischenbericht) {
          link = this.formularService.getRouteObjectThrough(response.abschnitteZwischenbericht[0]).link.split("/");
        }
        else {
          link = this.formularService.getRouteObjectThrough(this.anfrage.phase.abschnitte[0]).link.split("/");
        }
  
        let sectionType = link[0];
        let sectionId = link[1];
        let reportId = response.projektberichte[0].projektberichtId;

        this.portalContextService.Berichte = response.projektberichte;
        this.portalContextService.CurrentBericht = response.projektberichte[0];
        let promise = this.router.navigate(['../', 'reports', this.anfrage.objektTyp, this.anfrage.id, reportId, sectionType, sectionId], { relativeTo: this.route });
        this.loadingAnimationService.showSpinnerUsingPromise(promise);
      }
    })

    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  /**
   * Open Revoke Dialog on Revoke Click
   */
  public onRevokeClick() {
    this.revokeAnfrageDialog = this.dialogService.open({
      content: ConfirmationDialogComponent,
      maxWidth: Constants.DIALOG.MAX_WIDTH,
      maxHeight: Constants.DIALOG.MAX_HEIGHT,
      width: "25%",
      height: "25%",
      title: this.languageService.instant("dialogue.application.revoke.title.short")
    });

    let dialogComponent: ConfirmationDialogComponent = this.revokeAnfrageDialog.content.instance;

    dialogComponent.confirm = "dialogue.buttons.revoke";
    dialogComponent.content = "dialogue.application.revoke.title.long";

    this.revokeAnfrageDialog.result.subscribe(result => this.onRevokeProjektDialogClose(<ConfirmationDialogResult>result));
  }

  /**
   * Open application.
   */
  protected openApplication() {
    if (! this.anfrage.phase || ! this.anfrage.phase.abschnitte)
      throw new Error("Anfrage has no phase or abschnitte.");

    let link = this.formularService.getRouteObjectThrough(this.anfrage.phase.abschnitte[0]).link.split("/");

    let sectionType = link[0];
    let sectionId = link[1];

    this.router.navigate([
      '../',
      'detail',
      this.anfrage.objektTyp,
      this.anfrage.id,
      sectionType,
      sectionId
    ], { relativeTo: this.route });
  }

  /**
   * Delete Anfrage.
   */
  protected deleteAnfrage() {
    if (! this.anfrage.id || ! this.anfrage.objektTyp)
      throw new Error("Anfrage has no id or objektTyp."); 

    let subscription = this.anfrageService.apiAnfrageAnfrageIdScopeDelete({ anfrageId: this.anfrage.id, scope: this.anfrage.objektTyp }).subscribe(() => {
      this.anfrageDeleteEventEmitter.emit(this.anfrage);
      if (this.portalContextService.Anfragen)
        this.portalContextService.Anfragen = this.portalContextService.Anfragen.filter(anfrage => {
          return anfrage.id != this.anfrage.id;
        })
    });

    this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
  }

  protected openRevokeReasonApplicationDialog() {
    this.revokeReasonAnfrageDialog = this.dialogService.open({
      content: RevokeReasonAnfrageDialogComponent,
      maxWidth: Constants.DIALOG.MAX_WIDTH,
      maxHeight: Constants.DIALOG.MAX_HEIGHT,
      width: "25%",
      height: "25%",
      title: this.languageService.instant("dialogue.application.revoke.title.short")
    });

    let dialogComponent: RevokeReasonAnfrageDialogComponent = this.revokeReasonAnfrageDialog.content.instance;

    this.revokeReasonAnfrageDialog.result.subscribe(result => this.onRevokeReasonProjektDialogClose(<RevokeReasonAnfrageDialogResult>result));
  }

  protected onRevokeProjektDialogClose(result: ConfirmationDialogResult) {
    if (result.action == ConfirmationDialogAction.Confirm)
      this.openRevokeReasonApplicationDialog();
  }

  protected onRevokeReasonProjektDialogClose(result: RevokeReasonAnfrageDialogResult) {
    if (result.action == ConfirmationDialogAction.Confirm) {
      let revoke: RevokeDisplayModel = new RevokeDisplayModel();
      revoke.reason = result.reason;

      this.anfrageService.apiAnfrageAnfrageIdRevokePost({ "x-anfragescope": this.anfrage.objektTyp, anfrageId: this.anfrage.id, body: revoke })
        .subscribe(() => {
          this.instance?.markAsRevoked();
        });
    }
  }

  /**
   * Delete Anfrage on Dialog Close
   * 
   * @param result ConfirmationDialogResult
   */
  protected onDeleteProjektDialogClose(result: ConfirmationDialogResult) {
    if (result.action == ConfirmationDialogAction.Confirm) {
      this.deleteAnfrage();
    }
  }

  protected onMessageClick() {
    let dialogRef = this.dialogService.open({
      content: ChatDialogComponent,
      cssClass: "message-dialog",
      title: this.languageService.instant("application.message")
    });

    let dialogComponent: ChatDialogComponent = dialogRef.content.instance;

    dialogComponent.anfrageId = this.anfrage.id;
    dialogComponent.scope = this.anfrage.objektTyp!;
    dialogComponent.anfrageTitel = this.title;
    this.anfrage.anzahlUngelesenerNachrichten = 0;
  }

  protected onShareClick() {
    this.anfrageLiveSharingService.openFreigebenDialog(this.anfrage.id, this.anfrage.objektTyp!, this.title, false);
  }
}
